import React from "react";
import NiceModal, { useModal } from "@ebay/nice-modal-react"
import { useNavigate } from "react-router-dom";
import Form from "/src/components/form/Form";
import Modal from "/src/components/modal/Modal";
import useModalHelper from "/src/components/modal/hooks/useModalHelper";
import ButtonAction from "/src/components/UI/Button/Button";
import "./MigrationModalImport.css";
import { env } from "/src/var/env";
import userAction from "/src/features/user/actions/userAction";
import { useAuthDispatchContext } from "/src/features/auth/context/authContext";
import storage from "/src/utils/storage";
            
const MigrationModalImport = NiceModal.create(({ title, data}) => {
    const modal = useModal();
    const { onClose } = useModalHelper(modal);
    const dispatch = useAuthDispatchContext();
    const NB_LETTER_TEXT = 20;
    const importRequest = (e) => {

        if(e.target.innerText == 'Close') {
            return onClose();
        }
        const url = `${env.REACT_APP_API_PATH}/bot/migrate/${data.id}?token_auth=${storage('local').get('token')}&company=${storage('session').get('company').id}`;

        e.target.disabled = true;
        e.target.innerText = "Importing";
        var title = document.querySelector('.first-row .title');
        const DELTA = 50
        var paddingDot = title ? title.clientHeight - DELTA : 0;
        var paddingButton = paddingDot ? (paddingDot / DELTA + 1) : 1;
        var button = document.querySelector('.last-row');
        button.style.paddingTop = `${paddingButton * 20}px`;
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);

        xhr.send(null);
        var interval = null;
        xhr.onreadystatechange = async () => {
            if (xhr.status != 200) {
                return;
            }

            if (xhr.readyState == XMLHttpRequest.HEADERS_RECEIVED && interval == null){
                var i = 0;
                interval = setInterval(() => document.getElementById('dots').innerText = Array(i = i > 2 ? 0 : i + 1).fill(".").join(""), 500);
            }
            
            if (xhr.readyState == XMLHttpRequest.LOADING){
                let data = xhr.response.split('}').map(a => `${a}}`);
                data.pop();
                let actionJson = data.pop();
                var action = JSON.parse(actionJson);
                let progressbar = document.getElementById('progressbar');
                let information = document.getElementById('information-text');
                let dots = document.getElementById('dots');
                if(action.percent == null) {
                    clearInterval(interval);
                    progressbar.style.backgroundColor = "var(--pink)"
                    information.innerHTML = `${information.innerHTML}<br>Press ctrl + maj + i to get the error in the console`;
                    console.error(`${action.message[0]} line ${action.message[1]} in file ${action.message[2]}`)
                    e.target.className = 'button cancel';
                    e.target.innerText = 'Failed';
                    dots.style.display = 'none'; 
                }
                else {
                    information.innerHTML = action.message;
                    dots.style.left = `${(information.offsetWidth / 2) + (window.innerWidth / 2) + 3}px`;
                    let height = ((window.innerHeight/ 2) - 4) + paddingDot;
                    dots.style.top = `${height}px`;
                    progressbar.style.width = `${action.percent}%`
                    progressbar.innerHTML = `${action.percent}%`
                }
                

                //let tmpWidth = inputSpan.current.offsetWidth + paddingOffset;
                //let maxWidth = sizeOfDiv - divName.current.offsetWidth + paddingOffset;
                //tmpWidth = tmpWidth > maxWidth ? maxWidth : tmpWidth
            }
            if (xhr.readyState == XMLHttpRequest.DONE){
                clearInterval(interval);
                e.target.disabled = false;
                e.target.innerText = 'Close';
                document.getElementById('dots').style.display = 'none';
                if(document.getElementById('progressbar').innerHTML != '100%') return
                var data = await userAction.refreshUserInformation();
                if (!data) return;
                const { user, company, permissions } = data;
                storage('local').set('user', user);
                storage('session').set('company', company);
                storage('session').set('permissions', permissions);
                dispatch({type : 'refreshUserInfo', payload : {user, token : storage('local').get('token')}});
            //console.log('response',xhr.response);
            }
        }
    }

    return (
        <Modal name="migration-import" id={modal.id} autoClose={false} onClose={onClose}>
            <div>
                <div className="button-leave" id="close_modal_container" onClick={() => onClose({idIconModal:"close_modal_container"})} >
                    <i id="close_modal" className="fa fa-times" aria-hidden="true"></i>
                </div>
            </div>
            <Form className="modal-import">
                <Form.Title className="title-migrations-import">Run migration {data.name} </Form.Title>
                <Form.Body>
                    <div>
                        <div className="modal-import-container">
                            <div id="progressbar">0%</div>
                        </div>
                        <div id="information">
                            <div id="information-text" style={{textAlign:'center', fontWeight:'bold', position : 'absolute'}}>Migration {data.name.length > NB_LETTER_TEXT ? data.name.slice(0, NB_LETTER_TEXT) + "... " : data.name} is ready</div>
                            <span id='dots' style={{color: '#6e6e6e' }}></span>    
                        </div>
                    </div>
                </Form.Body>
                <Form.Buttons className="migration_import_start_button">
                    <ButtonAction className="validate" label="Start" type="button" onClick={importRequest}/>
                </Form.Buttons>
            </Form>
        </Modal >
    )
});
// <TextArea id="area_migration" onInput={(e)=> adaptTextAreaSize(e)} {...register('config', { required: true, minLength: 1, validate : value=>isJsonValid(value) })} style={errors.config ? { borderColor: "red" } : {}} placeholder="Configure your migration" />
export default MigrationModalImport;